module.exports = function (app) {
    'use strict';
    return app.factory('employerUtility', ['contentService','services', 'navigation', '$state',
        'sessionData', '$q', '$filter', 'storage', 'employee',
        function (contentService, services, navigation, $state, sessionData, $q, $filter, storage) {

            var getErrorMessage, errors, sidebarLinks, refreshSidebar, handleError, buildBreadCrumb, showFlashes,
                verifyTheyCanOpenEnrollments, makeEligibilityObj, makeGroupsArrayIntoAString,
                makeReportCodesArrayForUi, showEligibilitySubTable, configureFindADoc,
                addGuidToThisObject, addGuidsToArrayItems, updateParticipantByCoveredIndivId, addPropertiesToParticipants,
                makePayloadForChangePcp, getCurrentParticipant, getLobStuff, getParticipantsOtherThanThisOne,
                normalizeParticipantsData, copyOldPcpInfoToNewProperties, getLobStuffFromDependent, getProviderCancellationDate, normalizeReasonCodeDates;

            copyOldPcpInfoToNewProperties = function(theParticipant) {
                theParticipant.pcpNbrOld = angular.copy(theParticipant.pcpNbr);
                theParticipant.pcpNameOld = angular.copy(theParticipant.pcpName);
                theParticipant.pcpEffectiveDateOld = angular.copy(theParticipant.pcpEffectiveDate);
            };
            var theUbk = sessionData.employerInfo.brandName;


            var validateEffectiveDate=function(pcpDate,physicianCancellationDate){
                if(new Date(pcpDate) instanceof Date && new Date(physicianCancellationDate) instanceof Date && physicianCancellationDate!=''){
                    return physicianCancellationDate;
                }else{
                    return pcpDate;
                }
            };
            var getFormattedCancelDate = function(effective,cancel){
                var effD = new Date(effective);
                var canD = new Date(cancel);

                var cancelD = effD>canD ? effective : cancel;

                //curP.pcpEffectiveDateOld  formPCPEffectiveDate

                return  $filter('date')(cancelD, 'MMddyyyy');

            };

            var validatedPCP=function(pcpDate,physicianCancellationDate){
                var validatedPCPEffectiveDate=new Date();
                if(new Date(pcpDate) instanceof Date && new Date(physicianCancellationDate) instanceof Date && physicianCancellationDate!=''){
                    var formatPhyCanDate = new Date(physicianCancellationDate);
                    formatPhyCanDate.setDate(formatPhyCanDate.getDate() + 1);
                    validatedPCPEffectiveDate=formatPhyCanDate;
                }else{
                    validatedPCPEffectiveDate= pcpDate;
                }
                return validatedPCPEffectiveDate;
            };

            normalizeReasonCodeDates = function(reasonCodeObjs, cancellationDate) {
                var normalize = $filter('dateInput');
                reasonCodeObjs.forEach(function(rcObj) {
                    var validatePCPDate=validatedPCP(rcObj.effectiveDate,cancellationDate);
                    var formatvalidatePCPDate=new Date(validatePCPDate);
                    rcObj.effectiveDate = normalize( rcObj.effectiveDate);
                    rcObj.effDateForDisplay = $filter('date')(formatvalidatePCPDate, 'MM/dd/yyyy');
                });

                return reasonCodeObjs;
            };

            var trimReasonCodes = function(theRcs) {
                for (var i = 0; i < theRcs.length; i++) {
                    theRcs[i].reasonCode = (theRcs[i].reasonCode).trim();
                }
                return theRcs;
            };
            getProviderCancellationDate = function(participant){
                var memberCoverages = participant.memberCoverages || [];
                var cancelDate = "";
                var cancelDateFormated='';
                for(var i=0; i< memberCoverages.length; i++){
                    var providerInfo = memberCoverages[i].providerInformation;
                    if(providerInfo){
                        cancelDateFormated = providerInfo.physicianCancellationDate || '';
                    }
                }
                return cancelDateFormated? cancelDateFormated:cancelDate;
            }

            // we add properties here b c need to display each UI card w the same properties and to display dates properly
            //       and to preserve the Old pcp info which we need when submitting the change to the service
            normalizeParticipantsData = function($scope) {
                // the subscriber object for the display card does not have ssn, so we add it here
                $scope.provider.data.subscriber.ssn = $scope.employee.data.subscriber.ssn;
                // subscriber does not have a DOB either      $filter('date')(scope.employee.data.subscriber.birthDate, 'yyyy-MM-dd')
                // $scope.provider.data.subscriber.dob10Char = $filter('date')(scope.employee.data.subscriber.birthDate, 'yyyy-MM-dd');



                $scope.provider.data.reasonCodes = ((theUbk == '6009') || (theUbk == 6008))? $scope.provider.data.reasonCodes : trimReasonCodes($scope.provider.data.reasonCodes);

                if ($scope.provider.data.dependents) {
                    this.addGuidsToArrayItems($scope.provider.data.dependents);
                }
                this.addGuidToThisObject($scope.provider.data.subscriber);
                this.copyOldPcpInfoToNewProperties($scope.provider.data.subscriber)
                // format the coverage effective date for display in the UI
                this.addPropertiesToParticipants($scope.provider.data);
                var cancellationDate = getProviderCancellationDate($scope.employee.data.subscriber);
                normalizeReasonCodeDates($scope.provider.data.reasonCodes, cancellationDate);
            };





            getParticipantsOtherThanThisOne = function(thisGuid, allParticipants) {
                var arrPartis = [];
                if (allParticipants.dependents && allParticipants.dependents.length && allParticipants.dependents.length>0) {
                    var ds = allParticipants.dependents;
                    var s = allParticipants.subscriber;
                    if (s.guid != thisGuid) {
                        s.selected = false;
                        arrPartis.push(s)
                    }
                    // data-ng-if = "dependent.pcpNbr != '' "  There are some invalid items in dependents
                    for (var i = 0; i < ds.length; i++) {
                        if ((ds[i].guid != thisGuid) && (ds[i].pcpNbr != '') ) {
                            ds[i].selected = false;
                            arrPartis.push(ds[i]);
                        }
                    } }
                return arrPartis;
            }

            getLobStuffFromDependent = function(dep, groupNumber) {
                var lobStuff = {coverageEffectiveDate: '', coverageEndDate: ''};
                if (dep.memberCoverages[0] && dep.memberCoverages[0].memberLobs[0] ) {
                    var arrCovs = dep.memberCoverages;
                    var arrLobs = [];
                    for (var i = 0; i < arrCovs.length; i++) {
                        if (arrCovs[i].groupNumber == groupNumber) {
                            arrLobs = arrCovs[i].memberLobs;
                        } }
                    for (var j = 0; j < arrLobs.length; j++ ) {
                        if (arrLobs[j].coverageType == 'MEDICAL') {
                            lobStuff.coverageEffectiveDate = arrLobs[j].coverageEffectiveDate;
                            lobStuff.coverageEndDate = arrLobs[j].coverageEndDate;
                        } } }
                if (lobStuff.coverageEffectiveDate == '') { console.error('ERROR: there is no coverageEffectiveDate available.') }
                return lobStuff;
            };


            getLobStuff = function(scope) {
                // TODO: refactor this so that scope is not needed. - just the objects that are really used
                var lobStuff = {enrollmentSourceCode: '', lob: '', internalContractId: ''};
                var e = scope.employee.data;
                if (e && e.subscriber && e.subscriber.memberCoverages[0]
                    && e.subscriber.memberCoverages[0].memberLobs[0] ) {

                    var covs = e.subscriber.memberCoverages;
                    for (var k = 0; k < covs.length; k++) {
                        var gn = storage.get('changePcpSelectedGroupNumber')
                        if (covs[k].groupNumber == gn) {
                            lobStuff.internalContractId = covs[k].internalContractId;
                            var arrLobs = covs[k].memberLobs;

                            for (var j = 0; j < arrLobs.length; j++ ) {
                                if (arrLobs[j].coverageType == 'MEDICAL') {
                                    lobStuff.enrollmentSourceCode = arrLobs[j].enrollmentSourceCode;
                                    lobStuff.lob = arrLobs[j].lineOfBusiness;
                                    lobStuff.all = arrLobs[j];
                                } } } } }
                if (lobStuff.enrollmentSourceCode == '') { console.error('ERROR: there is no enrollmentSourceCode available.') }
                if (lobStuff.lob == '') { console.error('ERROR: there is no lineOfBusiness available.') }
                return lobStuff;
            };





            makePayloadForChangePcp = function(theScope, sd) {
                var curP = this.getCurrentParticipant(theScope.coveredIndivId, theScope.allParticipants);
                var bdUserId = 'B' + sd.employerInfo.planAdministrator.userId.toString();
                var theDob = $filter('date')(curP.dob10Char, 'MMddyyyy');
                // Next value is subscribers contractCovEffDte. There is another date at lobStuff.all.coverageEffectiveDate
                var pcpEffectiveDateOld = $filter('date')(curP.pcpEffectiveDateOld, 'MMddyyyy');
                //var pcpEffectiveDateNew = $filter('date')(curP.theReason.effectiveDate, 'MMddyyyy');// Date 09012018
                var provParticpant = [theScope.employee.data.subscriber].concat(theScope.employee.data.dependents || []).filter(
                    function(p) { return p.coveredIndividualId === curP.coveredIndivId;});
                var particpantMemCov = (provParticpant[0].memberCoverages || []).filter(function(cov){return cov.groupNumber === curP.contractId; });
                var physicianCancellationDate= particpantMemCov[0].providerInformation.physicianCancellationDate || '';// Date 2018-10-01
                var theUbk = sd.employerInfo.brandName;
                var pcpDate= ((theUbk == '6009') || (theUbk == '6008')) ? $filter('date')(curP.effectiveDateIB) : $filter('date')(curP.theReason.effectiveDate);
                //CR00756694
                var validatepcpEffectiveDateNew=validateEffectiveDate(pcpDate,physicianCancellationDate);
                var validatedPCPEffectiveDate= validatedPCP(pcpDate,physicianCancellationDate);
                var formChangePCPDate = new Date(validatedPCPEffectiveDate);
                var formPCPEffectiveDate=new Date(validatepcpEffectiveDateNew);
                var formatPCPEffecttiveDate = $filter('date')(formChangePCPDate, 'MMddyyyy');
                var formatPCPEffectiveDateNew = $filter('date')(formPCPEffectiveDate, 'MMddyyyy');
                var newPcpInfo = theScope.newPcpInfo;
                var lobStuff = this.getLobStuff(theScope, sd);
                var pcpType = 'PCP';// (curP.insuranceLineCde == 'HMO') ? 'PCP' : 'POR';

                // FIXES
                // for IBC, agreementId has to be curP.agreementNumber

                var conditionalAgreementId = ((theUbk == '6009') || (theUbk == 6008)) ? curP.agreementNumber : sd.theEmployee.data.subscriber.ssn + '0';
                var p = {};
                //var memberCurrent = this.getCurrentParticipant(theScope.coveredIndivId, [theScope.employee.data.subscriber].concat(theScope.employee.data.dependents || []));
                var pcpNum = 	storage.get('pcpNum');
                storage.del('pcpNum');
                // var memberCoverages = memberCurrent.memberCoverages || [];
                // for(var i=0; i< memberCoverages.length; i++){
                //     var providerInfo = memberCoverages[i].providerInformation;
                //     if(providerInfo){
                //         pcpNum = providerInfo.physicianNumber;
                //     }
                //
                // }
                try {
                    p = {
                        bdUserId: bdUserId,
                        coveredId: theScope.coveredIndivId,
                        reqTrackingFlag: "U",
                        contractId: lobStuff.internalContractId,       // curP.contractId,         //lobStuff.internalContractId,
                        agreementId: conditionalAgreementId,    // wpa OK.  curP.agreementNumber,
                        insuranceLineCde: curP.insuranceLineCde,
                        ntwkId: curP.ntwkId,
                        dob: theDob, // this erros on server $filter('date')(curP.dob10Char, 'MM/dd/yyyy'),
                        numOfRec: "1",
                        productInd: "",  // OK empty string
                        pcpInfo: [],
                        intakeRequest: {
                            bdUserId: bdUserId,  // PA ID, with a prefixed B
                            contactFirstName: curP.firstName,
                            contactMiddleName: curP.middleName,
                            contactLastName: curP.lastName,
                            memberFirstName: curP.firstName,
                            memberMiddleName: curP.middleName,
                            memberLastName: curP.lastName,
                            birthDate: $filter('date')(curP.dob10Char, 'MM/dd/yyyy'),
                            gender: "M",  // NOTE: we dont have curP gender so try empty string
                            relationshipCode: curP.relationshipCode || '',
                            enrollmentSourceCode: lobStuff.enrollmentSourceCode,
                            ecId: theScope.coveredIndivId,
                            umi: theScope.employee.data.umi,
                            lob: lobStuff.lob,
                            alphaPrefix: "YYR",  // Try an empty string here once the svc is working
                            groupNumber: curP.contractId,
                            benefitPlanName: lobStuff.all.lineOfBusiness,
                            coverageBeginDate: $filter('date')(lobStuff.all.coverageEffectiveDate, 'MM/dd/yyyy'),
                            coverageEndDate: lobStuff.all.coverageEndDate,             // "12/31/2017",
                            agreementId: curP.agreementNumber,
                            clientName: newPcpInfo.pcpName,  // the value in the form has been entered by the user
                            clientId: sd.employerInfo.planAdministrator.clientId.toString(),
                            coveredIndividualId: curP.coveredIndivId,
                            internalGroupNumber: lobStuff.internalContractId
                        }
                    };
                    var pcpInfoObj = {
                        // we need two of these in the array at payload.pcpInfo  (I know. Weird.)
                        type: pcpType,
                        msgArea: "",

                        // the OLD pcp /////////////////////////////
                        oldPcpNbr: curP.pcpNbrOld,
                        oldPcpName: (curP.pcpNameOld).substring(0, 34),
                        oldPcpEffDte: pcpEffectiveDateOld,
                        oldPcpCanDte: curP.pcpNbrOld ? getFormattedCancelDate(curP.pcpEffectiveDateOld ,formPCPEffectiveDate): '',
                        oldNtwkProviderId: "",  // OK as empty string
                        // the NEW pcp /////////////////////////////
                        pcpNbr: curP.pcpNbr,
                        pcpName: (curP.pcpName).substring(0, 34),
                        ntwkProviderId: "",
                        pcpPreExistingInd: newPcpInfo.pcpPreExistingInd,
                        pcpEffDte: ((theUbk == '6009') || (theUbk == 6008)) ? $filter('date')(curP.effectiveDateIB, 'MMddyyyy') : formatPCPEffecttiveDate,
                        pcpCanDte: '',
                        pcpCanCde: '',                     // "0",
                        pcpDenyCde: "",  // OK as empty string
                        blucdPrvNtwkId: "",  // OK as empty string
                        reasonCode: curP.theReason.reasonCode,
                        reasonDescription: curP.theReason.reasonDesc
                    }
                    /*if(pcpInfoObj.reasonDescription == "NO INITIAL PCP SELECTION"){
                     pcpInfoObj.pcpEffDte = addAMonth(pcpInfoObj.pcpEffDte) ;
                     }*/
                    p.pcpInfo.push(pcpInfoObj);
                    p.pcpInfo.push(pcpInfoObj);
                    return p;
                } catch (e) {
                    console.log("e",e);
                    return null;
                }
            }

            var setNoPcpPreviouslySelected = function(thePerson) {
                // these rules are as per Sunils email of 8/28/17, 112:22 PM
                if ((thePerson.pcpNbr == '002759262') ||(thePerson.pcpNbr == '999999')
                    || ((thePerson.pcpNbr).substring(0,2) =='BC') || ((thePerson.pcpNbr).substring(0,2) =='IP') ) {
                    thePerson.pcpName = '';
                    thePerson.pcpNbr = '';
                    thePerson.theReason = thePerson.theReason || {};
                    thePerson.theReason.reasonCode = '25';
                    thePerson.theReason.reasonCode = 'NO INITIAL PCP SELECTION';
                };
                return thePerson;
            }

            // we need to add some properties for display purposes; and remove dud dependents
            addPropertiesToParticipants = function(allParticipants) {
                var showChgPcpCopyToOthers = false;
                //  provider.data.dependents.length > 0
                if (allParticipants.dependents && allParticipants.dependents.length && allParticipants.dependents.length>0) {
                    showChgPcpCopyToOthers = true;
                }
                if (allParticipants.subscriber && allParticipants.subscriber){
                    allParticipants.subscriber.contractCovEffDteForDisplay = $filter('date')(allParticipants.subscriber.contractCovEffDte, 'MM/dd/yyyy');
                    allParticipants.subscriber = setNoPcpPreviouslySelected(allParticipants.subscriber);
                    allParticipants.subscriber.showChgPcpCopyToOthers = showChgPcpCopyToOthers;
                }
                if (allParticipants.dependents && allParticipants.dependents.length && allParticipants.dependents.length>0){
                    var ds = allParticipants.dependents;
                    var s = allParticipants.subscriber;
                    for (var i = 0; i < ds.length; i++) {
                        ds[i].theReason = {
                            reasonCode: '',
                            reasonDesc: ''
                        };
                        ds[i].agreementNumber = s.agreementNumber;
                        ds[i].contractCovEffDte = s.contractCovEffDte;
                        // curP.contractId = '10050516'
                        ds[i].contractId = s.contractId;
                        ds[i].contractCovEffDteForDisplay = $filter('date')(s.contractCovEffDte, 'MM/dd/yyyy');
                        ds[i].homeCity = s.homeCity;
                        ds[i].homeState = s.homeState;
                        ds[i].homeZip = s.homeZip;
                        copyOldPcpInfoToNewProperties(ds[i]);
                        ds[i] = setNoPcpPreviouslySelected(ds[i]);
                        ds[i].showChgPcpCopyToOthers = showChgPcpCopyToOthers;
                    }
                } };

            getCurrentParticipant = function(coveredIndivId, allParticipants) {
                var curP = null;
               if(allParticipants.subscriber){
                   allParticipants = [allParticipants.subscriber].concat(allParticipants.dependents || []);
               }
                var arrDs = allParticipants;
                for (var i = 0; i < arrDs.length; i++) {
                    if (arrDs[i].coveredIndivId === coveredIndivId || arrDs[i].coveredIndividualId === coveredIndivId) {
                        curP = arrDs[i];
                    }
                }
                // if (s.coveredIndivId == coveredIndivId) {
                //     curP = s;
                // }
                // if (allParticipants.dependents && allParticipants.dependents.length && allParticipants.dependents.length>0) {
                //     var arrDs = allParticipants.dependents;
                //     for (var i = 0; i < arrDs.length; i++) {
                //         if (arrDs[i].coveredIndivId == coveredIndivId) {
                //             curP = arrDs[i];
                //         }
                //     }
                // }
                return curP;
            }

            updateParticipantByCoveredIndivId = function(coveredIndivId, allParticipants, qsParams) {
                if (!coveredIndivId || coveredIndivId == '') {
                    console.error('ERROR: updateParticipantByCoveredIndivId did not receive a value for coveredIndivId');
                }
                var curParticipant = getCurrentParticipant(coveredIndivId, allParticipants);
                if (curParticipant) {
                    curParticipant.pcpNbr = qsParams.PCPNumber;
                    curParticipant.pcpName = decodeURIComponent(qsParams.PCPNAME);
                } else {
                    console.error('ERROR: updateParticipantByCoveredIndivId did not find the current participant.')
                }
            }
            var newGuid = function() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    var r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8);
                    return v.toString(16);
                });
            }
            addGuidToThisObject = function(theObj) {
                theObj.guid = newGuid();
            }
            addGuidsToArrayItems = function(theArray) {
                if (Array.isArray(theArray)) {
                    for (var i = 0; i<theArray.length; i++) {
                        addGuidToThisObject(theArray[i]);
                    }
                }
            }
            configureFindADoc = function(returnPath, theScope, strGroupName, index) {
                index = index || '0';
                // we edit the providerLink.url value, adding name-value pairs
                var tt = theScope;
                var ff = sessionData;
                var ubk = sessionData.employerInfo.brandName;
                var clientId = sessionData.employerInfo.planAdministrator.clientNumber;
                var brandCode;
                switch(ubk) {
                    case '6008':
                        if (sessionData.isIbcAhpa == true) {
                            brandCode = 'AHPA';
                        } else {
                            brandCode = 'IBC';
                        }
                        break;
                    case '6009':
                        brandCode = 'AHNJ';
                        break;
                    default:
                        brandCode = null;
                        break;
                }
                var groupNumber = theScope.participant.contractId;
                var theDomain = window.location.hostname;
                var p = theScope.participant;
                var theUrl;
                var isTestEnvironment = /([dt]env([0-9]|[abcdet]))/.test(window.location.host);
                // IBC and AHPA get the same url  ubk = 6008
                if (ubk == '6008') {
                    // IBC and AHNJ  ... for IBC group AHPA we have set the value of brandCode about 10 lines above
                    theUrl = 'https://ibxpress.ibx.com/RedirectWeb/RedirectServlet';
                    theUrl += '?clientNumber=' + clientId;
                    theUrl += '&groupNumber=' + groupNumber;
                    theUrl += '&brandCode=' + brandCode + '&speciality=pcp';
                } else if (ubk =='6009') {
                    // IBC AHNJ gets a distinct url  ubk = 6009
                    theUrl = 'https://amerihealthexpress.amerihealth.com/RedirectWeb/RedirectServlet'
                    theUrl += '?clientNumber=' + clientId;
                    theUrl += '&groupNumber=' + groupNumber;
                    theUrl += '&brandCode=' + brandCode + '&speciality=pcp';
                } else if(sessionData.appConfig && sessionData.appConfig.findAProvider && sessionData.appConfig.findAProvider.booleanValue && ubk == 6011) {
                    // add new url when user click Find a Provide link every where for ND
                    if(isTestEnvironment){
                        theUrl = 'https://uat.highmark.sapphirecareselect.com/?ci=bcbsnd';
                    } else {
                        theUrl = 'https://bcbsnd.sapphirecareselect.com/?ci=bcbsnd';
                    }
                } else if(sessionData.appConfig && sessionData.appConfig.findAProvider && sessionData.appConfig.findAProvider.booleanValue && ubk == 6012) {
                    // add new url when user click Find a Provide link every where for WY
                    if(isTestEnvironment){
                        theUrl = 'https://uat.highmark.sapphirecareselect.com/?ci=bcbswy';
                    } else {
                        theUrl = 'https://bcbswy.sapphirecareselect.com/?ci=bcbswy';
                    }
                } else if(sessionData.appConfig && sessionData.appConfig.findAProvider && sessionData.appConfig.findAProvider.booleanValue && ubk == 6010) {
                    // add new url when user click Find a Provide link every where for MN
                    if(isTestEnvironment){
                        theUrl = 'https://uat.highmark.sapphirecareselect.com/?ci=bcbsmn';
                    } else {
                        theUrl = 'https://findadoctormn.sapphirecareselect.com/?ci=bcbsmn';
                    }
                }
                else {
                    theUrl = 'https://' + window.location.host + '/find-a-doctor/#/home' +
                        '?pcpIndex=' + index +
                        '&pcp=true' +
                        '&productName=' + strGroupName +
                        '&returnUrl=' + theDomain + returnPath +
                        '&fromPage=changePCP';

                    var c = (p.homeCity) ? '&city=' + p.homeCity : '';  // p is participant - the person who clicked the link
                    var s = (p.homeState) ? '&state=' + p.homeState : '';
                    var z = (p.homeZip) ? '&zipcode=' + (p.homeZip).substring(0,5) : '';
                    // we add city, state, and zip if they exist as properties for the person who clicked the link
                    theUrl += c + s + z;
                }
                return {
                    url: theUrl,
                    newWindow: Boolean((sessionData.employerInfo.brandName == '6008') || (sessionData.employerInfo.brandName == '6009') || (sessionData.employerInfo.brandName == '6010'))

                };
            };

            showEligibilitySubTable = function(arrLeft, arrRight) {
                var showIt = true;
                var countOfEligibilities = arrLeft.length + arrRight.length;
                var countOfDeclines = 0;
                for (var i = 0; i < arrLeft.length; i++) {
                    countOfDeclines = (arrLeft[i].icon == 'decline') ? countOfDeclines+1 : countOfDeclines;
                }
                for (i = 0; i < arrRight.length; i++) {
                    countOfDeclines = (arrRight[i].icon == 'decline') ? countOfDeclines+1 : countOfDeclines;
                }
                showIt = (countOfDeclines == countOfEligibilities) ? false : true;
                return showIt;
            };

            var removeLastCommaAndSpace = function(strBad) {
                var startPos = strBad.lastIndexOf(', ');
                var strFixed = strBad.substring(0, startPos);
                return strFixed;
            };
            makeReportCodesArrayForUi = function(thePayload) {
                var arrRows = [];

                for (var j = 0; j < thePayload.length; j++) {
                    var newCodeLabel = '';
                    var newTypeLabel = thePayload[j].type + ' (' + thePayload[j].abbreviatedType + ')';
                    for (var i = 0; i < thePayload[j].codes.length; i++) {
                        newCodeLabel += thePayload[j].codes[i] + ', ';
                    }
                    newCodeLabel = removeLastCommaAndSpace(newCodeLabel);
                    var reportCodesObjForUi = {
                        type: newTypeLabel,
                        strCodes: newCodeLabel
                    }
                    arrRows.push(reportCodesObjForUi);
                }
                return arrRows;
            }
            makeGroupsArrayIntoAString = function(thePayload) {
                var strGroups = '';
                var strCodes = '';
                for (var i = 0; i < thePayload.length; i++) {
                    strCodes = '';  strGroups = '';
                    for (var j=0; j<thePayload[i].associatedGroups.length; j++) {
                        var aNumber = (thePayload[i].associatedGroups[j] + ", ");
                        strGroups += aNumber;
                    }
                    thePayload[i].groups = removeLastCommaAndSpace(strGroups);
                    // now iterate the codes.  Its a string array
                    for (var k = 0; k < thePayload[i].codes.length; k++) {
                        var aCode = (thePayload[i].codes[k] + ", ");
                        strCodes += aCode;
                    }
                    thePayload[i].strCodes = removeLastCommaAndSpace(strCodes);
                    // add abbreviation to the type property
                    thePayload[i].type = thePayload[i].type + ' (' + thePayload[i].abbreviatedType + ')';
                }
            }
            makeEligibilityObj = function(thePayload) {
                var objEligibility = {};
                // make object for bottom section of Eligibility ====================
                var arrDependentTypes = [];
                var itemsFromSvc = thePayload.dependentEligibility;
                for (var propertyName in itemsFromSvc) {
                    if (itemsFromSvc.hasOwnProperty(propertyName)) {
                        var dependentType = {
                            dependentType: propertyName,
                            eligibleToAge: itemsFromSvc[propertyName].eligibleAge,
                            terminate: itemsFromSvc[propertyName].termination
                        }
                        arrDependentTypes.push(dependentType);
                    } }
                objEligibility.dependentTypes = arrDependentTypes;
                // make objects for top part of Eligibility ===========================
                var arrRight = [];
                var p = thePayload;
                var iconValue = 'decline';
                iconValue = (p.dependentsCovered) ? 'approved' : 'decline';
                arrRight.push({ icon: iconValue, desc: 'Dependents' });
                iconValue = (p.domesticPartners) ? 'approved' : 'decline';
                arrRight.push({ icon: iconValue, desc: 'Domestic Partners' });
                objEligibility.arrRight = arrRight;
                var arrLeft = [];
                iconValue = (p.studentReporting) ? 'approved' : 'decline';
                arrLeft.push({ icon: iconValue, desc: 'Student Reporting' });
                iconValue = (p.studentsCovered) ? 'approved' : 'decline';
                arrLeft.push({ icon: iconValue, desc: 'Students Covered' });
                objEligibility.arrLeft = arrLeft;
                return objEligibility;
            }

            verifyTheyCanOpenEnrollments = function() {
                if (!sessionData.entitlements.viewEmployees) {
                    $state.go('home');
                }
            }

            var siteAccessMap = {
                'EP Enrollment Reports': "Enrollment Reports",
                'EP MedeAnalytics': "Mede Analytics",
                'EP Protecting Identity': "ID Theft protection",
                'EP Reports at Hand': "Reports",
                'EP ViewBills': "Bills",
                'EPWellness Reports': "Wellness",
                'ucciDental': "Dental"
            };

            getErrorMessage = function (error) {
                var output = {};
                var contentServicePromise = contentService.getAll("epr_service_errors");
                return contentServicePromise.then(function (response) {
                    errors = response;
                    if (error.data && error.data.baseMessage && errors[error.data.baseMessage.returnCode]) {
                        output.message = errors[error.data.baseMessage.returnCode];
                    } else {
                        output.message = errors.generic;
                    }
                    return output;
                });
            }

            sidebarLinks = function (params) {
                var createFlow=params.createFlow ? params.createFlow : 'false';
                //undefined value will also be true
                var isAnEdit=params.isAnEdit ? params.isAnEdit : 'false';
                var queryParams = "({" +
                    "loginId:'" + params.loginId + "'," +
                    "isAnEdit:'" + isAnEdit + "'," +
                    "clientNumber:'" + params.clientNumber + "'," +
                    "createFlow:'" + createFlow + "'" +
                    "})";
                var links = [
                    {
                        heading: "Demographics",
                        label: "Demographics",
                        state: "add-plan-admin.demographics" + queryParams
                    },
                    {
                        heading: "Overall Entitlements",
                        label: "Overall Entitlements",
                        state: "add-plan-admin.user-entitlements" + queryParams,
                        hideItem: false
                    },
                    {
                        heading: "Group Entitlements",
                        label: "Group Entitlements",
                        state: "add-plan-admin.group-entitlements" + queryParams,
                        hideItem: false
                    },
                    {
                        heading: "Dental (UCD)",
                        label: "Dental (UCD)",
                        state: "add-plan-admin.dental-entitlements" + queryParams,
                        hideItem: true
                    },
                    {
                        heading: "Billing",
                        label: "Billing",
                        state: "add-plan-admin.billing-entitlements" + queryParams,
                        hideItem: true
                    }];
                if(params.isAnEdit==='false'){
                    return [
                        {
                            heading: "Demographics",
                            label: "Demographics",
                            state: "add-plan-admin.demographics" + queryParams
                        }
                    ];
                }else {
                    return links;
                }
            };

            refreshSidebar=function(sidebar,currentState,hasUCDDental,hasBilling){
                for(var index in sidebar.links){
                    if(sidebar.links[index].state.indexOf(currentState)>=0){
                        sidebar.links[index].active=true;
                    }else{
                        sidebar.links[index].active=false;
                    }
                    if(sidebar.links[index].state.indexOf("add-plan-admin.dental-entitlements")>=0){
                        sidebar.links[index].hideItem=hasUCDDental?false:true;
                    }else if(sidebar.links[index].state.indexOf("add-plan-admin.billing-entitlements")>=0){
                        sidebar.links[index].hideItem=hasBilling?false:true;
                    }else{
                        sidebar.links[index].hideItem=false;
                    }
                }
            };

            handleError=function(feedback,error){
                getErrorMessage(error).then(function(response){
                    feedback.addFeedback(response.message,"warning");
                });
            };

            showFlashes=function(flashes,notificationType,id){
                contentService.get(id).then(function(response){
                    flashes.addFeedback(response,notificationType);
                });
            };

            buildBreadCrumb=function(sidebar,demographicInfo){
                if(!sidebar.breadCrumb){
                    sidebar.breadCrumb={
                        secondary: {
                            title: ''
                        }
                    };
                }else if(sidebar.breadCrumb.secondary && sidebar.breadCrumb.secondary.title && sidebar.breadCrumb.secondary.title.length>0){
                    return;
                }
                sidebar.breadCrumb.secondary.title = "Edit " + demographicInfo.loginId + ' ' + demographicInfo.firstName + ' ' + demographicInfo.lastName;
            }

            return {
                siteAccessMap: siteAccessMap,
                getErrorMessage: getErrorMessage,
                sidebarLinks: sidebarLinks,
                refreshSidebar: refreshSidebar,
                handleError: handleError,
                buildBreadCrumb: buildBreadCrumb,
                showFlashes: showFlashes,
                verifyTheyCanOpenEnrollments: verifyTheyCanOpenEnrollments,
                makeEligibilityObj: makeEligibilityObj,
                makeGroupsArrayIntoAString: makeGroupsArrayIntoAString,
                makeReportCodesArrayForUi: makeReportCodesArrayForUi,
                showEligibilitySubTable: showEligibilitySubTable,
                configureFindADoc: configureFindADoc,
                addGuidToThisObject: addGuidToThisObject,
                addGuidsToArrayItems: addGuidsToArrayItems,
                updateParticipantByCoveredIndivId: updateParticipantByCoveredIndivId,
                addPropertiesToParticipants: addPropertiesToParticipants,
                makePayloadForChangePcp: makePayloadForChangePcp,
                getCurrentParticipant: getCurrentParticipant,
                getLobStuff: getLobStuff,
                getParticipantsOtherThanThisOne: getParticipantsOtherThanThisOne,
                normalizeParticipantsData: normalizeParticipantsData,
                copyOldPcpInfoToNewProperties: copyOldPcpInfoToNewProperties,
                getLobStuffFromDependent: getLobStuffFromDependent,
                getProviderCancellationDate: getProviderCancellationDate,
                normalizeReasonCodeDates: normalizeReasonCodeDates
            };
        }]);
};